import React from 'react';
import { makeAutoObservable } from 'mobx';
import { observer } from 'mobx-react';
import { CommandBar, ICommandBarItemProps, mergeStyleSets } from '@fluentui/react';

import { FieldType, IEntityColumn, IGenericEntity, IUserConfigPackage } from '../../API';
import EntityDashboard from '../dashboards/EntityDashboard';
import { PopupWindow } from '../../state/PopupWindow';

const classNames = mergeStyleSets({
	table: {
		width: '100%',
		borderCollapse: 'collapse',
	},
	labelCell: {
		color: '#999',
		fontSize: 12,
		fontWeight: 400,
		padding: '6px 16px 6px 0',
		verticalAlign: 'top',
		whiteSpace: 'nowrap',
		width: '1%',
	},
	valueCell: {
		padding: '6px 0',
		verticalAlign: 'top',
	},
});

export class EntityPropertiesState {
	public columns: IEntityColumn[];
	public item: IGenericEntity;
	public userConfig: IUserConfigPackage;

	public constructor(userConfig: IUserConfigPackage, columns: IEntityColumn[], item: IGenericEntity) {
		makeAutoObservable(this);
		this.userConfig = userConfig;
		this.columns = columns;
		this.item = item;
	}

	public ensureLoaded() {
	}
	
	
	public showEditForm(id: string) {
		PopupWindow.show((this.item as any).NativeMetadataUrl + "&helmUX=1");
	}
}

export interface IEntityPropertiesProps {
	state: EntityPropertiesState;
}

class EntityProperties extends React.Component<IEntityPropertiesProps> {

	componentDidMount() {
		this.props.state.ensureLoaded();
	}

	private get commandBarItems(): ICommandBarItemProps[] {
		return [
			{
				key: 'properties',
				text: 'Edit Properties',
				iconProps: { iconName: 'Edit' },
				onClick: () => this.props.state.showEditForm(this.props.state.item.Id),
			},
		];
	}


	render() {
		const { columns, item, userConfig } = this.props.state;

		const showFieldTypes = [FieldType.Calculated, FieldType.Choice, FieldType.Currency, FieldType.DateTime, 
			FieldType.Integer, FieldType.Lookup, FieldType.Text, FieldType.Note, FieldType.Boolean, FieldType.MultiChoice, FieldType.User];

		const rows = columns
			.filter(c => !c.isHidden && !c.id.startsWith('_')  && showFieldTypes.indexOf(c.fieldType) !== -1)
			.map(column => {
				const value = (item as any)[column.id];
				if (value === undefined || value === null) return null;

				const displayValue = EntityDashboard.displayPropertyValue(
					item,
					userConfig,
					column,
					value,
					false,
				);

				return (
					<tr key={column.id}>
						<td className={classNames.labelCell}>{column.displayName}</td>
						<td className={classNames.valueCell}>{displayValue}</td>
					</tr>
				);
			});

		return (<div>
				<CommandBar items={this.commandBarItems} />
				<table className={classNames.table}>
					<tbody>{rows}</tbody>
				</table>
			</div>
		);
	}
}

export default observer(EntityProperties);
